import { render, staticRenderFns } from "./lifecycle-periods.vue?vue&type=template&id=297ba029&scoped=true&"
import script from "./lifecycle-periods.vue?vue&type=script&lang=js&"
export * from "./lifecycle-periods.vue?vue&type=script&lang=js&"
import style0 from "./lifecycle-periods.vue?vue&type=style&index=0&id=297ba029&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297ba029",
  null
  
)

export default component.exports